<template>
    <section class="hero-section">
        <div class="hero-overlay"></div>
        <v-container class="hero-content text-center d-flex flex-column align-center justify-center">
            <img src="@/assets/icons/compass.png" height="100" alt="">
            <div class="main-title">
                <h1 class="hero-title font-dm-serif">PASSPORT</h1>
                <h1 class="font-dm-serif">TO</h1>
                <h1 class="hero-title font-dm-serif">&lsquo;I DO&rsquo;</h1>
                <template v-if="!hideDetails">
                    <h1 class="font-dancing-script-400 text-gold">
                        Your Journey to Forever Starts Here
                    </h1>
                    <div class="d-flex justify-center mt-5">
                        <div class="px-3">
                            <img src="@/assets/icons/ring.png" height="40" alt="Hero Image">
                            <div class="text-sm"><strong>WEDDINGS </strong></div>
                        </div>
                        <v-divider vertical></v-divider>
                        <div class="px-5">
                            <img src="@/assets/icons/plane.png" height="40" alt="Hero Image">
                            <div class="text-sm"><strong>TRAVEL</strong></div>
                        </div class="px-3">
                        <v-divider vertical></v-divider>
                        <div class="px-3">
                            <img src="@/assets/icons/confetti.png" height="40" alt="Hero Image">
                            <div class="text-sm"><strong>CELEBRATIONS</strong></div>
                        </div>
                    </div>
                    <p class="hero-subtitle mt-5" v-if="!hideSubtitle">
                        From dream weddings to unforgettable travel experiences,
                        organize your life moments beautifully with one registration.
                    </p>

                    <v-container v-if="eventDetails.id != undefined" style="margin-bottom: -22px">
                        <div class="d-flex justify-center">
                            <v-card max-width="600">
                                <v-card-text class="d-flex justify-center">
                                    <div class="px-3 primary--text">
                                        <v-icon class="primary--text">mdi-calendar</v-icon> {{ eventDetails.display_date }}
                                    </div>
                                    <v-divider vertical></v-divider>
                                    <div class="px-3 primary--text">
                                        <v-icon class="primary--text">mdi-map-marker</v-icon> {{ eventDetails.location }}
                                    </div>
                                </v-card-text>
                            </v-card>
                        </div>
                    </v-container>
                </template>
            </div>
        </v-container>
    </section>
</template>
<script>
import axios from 'axios';
export default {
    name: 'Header',
    props: ['hideDetails', 'hideSubtitle', 'eventDetails'],
}
</script>
<style scoped>
.main-title {
    color: #1a3765;
}

/* HERO */
.hero-section {
    position: relative;
    overflow: hidden;
    background-image: url("@/assets/passport-banner/banner.png");
    background-size: cover;
    background-position: bottom center;
}

.hero-overlay {
    position: absolute;
    inset: 0;
}

.hero-content {
    position: relative;
    z-index: 2;
}

.hero-title {
    font-size: 58px;
    line-height: 1.1;
    font-weight: 800;
    color: #1a3765;
}

.hero-subtitle {
    font-size: 18px;
    line-height: 1.8;
    max-width: 560px;
}

/* PASSPORT CARD */
.passport-card {
    position: relative;
}

.passport-img {
    width: 420px;
    border-radius: 28px;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);
}

.floating-badge {
    position: absolute;
    bottom: -20px;
    right: -20px;

    background: #5d4037;
    color: white;

    padding: 14px 20px;
    border-radius: 40px;

    display: flex;
    align-items: center;
    gap: 10px;

    font-weight: 600;
}


@media (max-width: 768px) {
    .hero-section {
        background-image:
            linear-gradient(rgba(255, 255, 255, 0.78),
                rgba(255, 255, 255, 0.75)),
            url("@/assets/passport-banner/banner2.png");
        /* background-image: url("@/assets/passport-banner/banner-mobile.png"); */
        background-size: cover;
        background-position: left center;
    }


    .stepper-wrapper {
        gap: 0px;
    }
}
</style>